
import { createAction } from 'typesafe-actions';
import { IChemicalFillingPoint } from '../../../@types/model/fillingPoint/chemical';

export default class FillingPointChemicalActions {
    public static readonly setList = createAction('FILLING_POINT_SET_POINTS', resolve => (data ?: Array<IChemicalFillingPoint>) => resolve(data));
    public static readonly setLoading = createAction('FILLING_POINT_SET_LOADING_POINTS', resolve => (data : boolean) => resolve(data));
    public static readonly setSelected = createAction('FILLING_POINT_SET_SELECTED_POINTS', resolve => (data ?: string) => resolve(data));
}